<template src="./CreaEditaGrupoTipos.html"></template>
<script>
  import HttpUtil from '../../util/HttpUtil'
  import Mensajes from '../../util/Mensajes'
  import ManejaError from '../../util/ManejaError'

  export default {
    data () {
      return {
        status: {
          enviando: false
        },
        validacion: {
          error: false,
          mensajes: {}
        }
      }
    },
    props: ['id', 'grupo'],
    mounted () {
      this.form = jQuery('#' + this.id + 'form')
      this.httpgrupoTipos = new HttpUtil('grupoTipos')
      let modalClosed = () => {
        this.form.form('clear')
      }
      this.modalInstance = jQuery(this.$el).modal({
        onApprove: () => {
          this.form.form('validate form')
          return false
        },
        onHide: modalClosed,
        onDeny: modalClosed,
        autofocus: false
      })
      this.form.form({
        inline: true,
        fields: {
          nombre_grupo: {
            rules: [{
              type: 'empty',
              prompt: 'nombre del grupo es requerido'
            }]
          }
        },
        onSuccess: this.guardar
      })
    },
    methods: {
      manejaError: function (response) {
        this.validacion.error = true
        this.status.enviando = false
        this.validacion.mensajes = ManejaError(response)
      },
      manejaOk: function (response) {
        this.validacion.error = false
        this.status.enviando = false
        this.$emit('success', {data: response.data.data})
        this.modalInstance.modal('hide')
        Mensajes.success('proceso realizado')
      },
      guardar: function () {
        if (this.status.enviando) {
          return false
        }
        this.status.enviando = true
        this.validacion.error = false

        if (typeof this.grupo.id === 'undefined') {
          this.httpgrupoTipos.create(this.grupo, this.manejaOk, this.manejaError)
        } else {
          this.httpgrupoTipos.update(this.grupo, this.manejaOk, this.manejaError)
        }
        return false
      }
    },
    destroyed: function () {
      this.modalInstance.remove()
    }
  }
</script>




// WEBPACK FOOTER //
// src/components/GrupoTipos/CreaEditaGrupoTipos.vue